document.addEventListener("DOMContentLoaded", function() {
  const slider = document.querySelector(".promo-cards-track");
  const nextBtn = document.querySelector(".promo-next-btn");
  const prevBtn = document.querySelector(".promo-prev-btn");
  const cards = document.querySelectorAll(".promo-card-item");
  const container = document.querySelector(".promo-section-wrapper");

  // Exit if elements are missing
  if (!slider || cards.length === 0 || !container) return;

  // Run slider logic only on desktop
  if (window.innerWidth > 768) {
    let currentIndex = 0;
    const gap = 20;
    const cardWidth = cards[0].offsetWidth + gap;

    function updateSlider() {
      const containerWidth = container.offsetWidth;
      const visibleCards = Math.floor(containerWidth / cardWidth);
      const maxIndex = Math.max(cards.length - visibleCards, 0);

      // Calculate the max scrollable distance
      const maxScroll = slider.scrollWidth - containerWidth;
      const translateX = Math.min(currentIndex * cardWidth, maxScroll);

      slider.style.transform = `translateX(-${translateX}px)`;

      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = translateX >= maxScroll;
    }

    nextBtn.addEventListener("click", () => {
      currentIndex++;
      updateSlider();
    });

    prevBtn.addEventListener("click", () => {
      currentIndex--;
      updateSlider();
    });

    updateSlider();

    // Recalculate on window resize
    window.addEventListener("resize", updateSlider);
  }
});
